import styled from 'styled-components';

export const PreviewContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const ContentWrapper = styled.div<{ $isBlocked: boolean }>`
  width: 100%;
  height: 100%;
  opacity: ${({ $isBlocked }) => ($isBlocked ? '0.4' : '1')};
  pointer-events: ${({ $isBlocked }) => ($isBlocked ? 'none' : 'auto')};
  user-select: ${({ $isBlocked }) => ($isBlocked ? 'none' : 'auto')};
  transition: all 0.3s ease;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.3);
`;

export const UpgradeCard = styled.div`
  position: relative;
  max-width: 480px;
  width: 100%;
  background: white;
  border-radius: 20px;
  padding: 32px 28px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 0 20px;
  pointer-events: auto;
  text-align: center;

  @media (max-width: 640px) {
    padding: 28px 20px;
    max-width: 90%;
  }

  @media (max-width: 320px) {
    padding: 24px 16px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  transition: all 0.2s ease;
  border-radius: 8px;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
  }

  @media (max-width: 640px) {
    top: 12px;
    right: 12px;
    padding: 4px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  @media (max-width: 320px) {
    top: 8px;
    right: 8px;
    padding: 4px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const Icon = styled.div`
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const Title = styled.h2`
  font-size: 18px !important;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
  line-height: 1.3;
  letter-spacing: normal;

  @media (max-width: 640px) {
    font-size: 16px !important;
  }
`;

export const Description = styled.p`
  font-size: 14px !important;
  color: #64748b;
  margin: 0 0 20px 0;
  line-height: 1.5;
  letter-spacing: normal;

  @media (max-width: 640px) {
    font-size: 13px !important;
  }
`;

export const UpgradeButton = styled.button`
  background: #000000;
  color: white;
  border: none;
  border-radius: 10px;
  height: 30px;
  padding: 0 40px;
  font-size: 15px !important;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  letter-spacing: normal;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @media (max-width: 640px) {
    padding: 0 24px;
    font-size: 14px !important;
  }
`;

export const OKButton = styled.button`
  background: #000000;
  color: white;
  border: none;
  border-radius: 10px;
  height: 30px;
  padding: 0 40px;
  font-size: 15px !important;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  letter-spacing: normal;
  margin-top: 8px;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @media (max-width: 640px) {
    padding: 0 24px;
    font-size: 14px !important;
  }
`;
